import { BreadCrumbClickableItemTemplate } from 'app/src/shared/components'

export function CatalogProductBreadcrumbItem(props: { productName: string | null }) {
  if (props.productName)
    return BreadCrumbClickableItemTemplate({
      label: props.productName,
    })
}
